import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, Stack } from '@mui/material';
import objectHash from 'object-hash';
import { useContext, useEffect, useState } from 'react';
import { v4 } from 'uuid';
import { AppMainViewContext } from '../../../ContextProviders/AppContextProvider';
import { ActionIcons } from '../../../Iconography';
import { ConsumerDao } from '../../../data/ConsumerDAO';
import { Severity } from '../../../types';
import { DataGridRadioColumn } from '../../../util/DataGrid/DataGridHelpers';
import { viewDefinitionToGridColumnMap } from '../../../v2/components/generic/transformFns';
import { GroupViewDefinition } from '../../SytemManagement/Devices/DeviceGatewayGroupViewSubParts';
import { StripedDataGrid } from '../DataGrid';
const debug = process.env.REACT_APP_DEBUG && false;
export const QueryObjectSearch = ({ branchingQueryDefinition, resultFilter, searchRootObjects, linkableItemsViewDefinition, handleLink, matchedPrimary, visibleGroupsOnly, }) => {
    const [linkListItems, setLinkListItems] = useState(undefined);
    const [selectedLinkItems, setSelectedLinkItems] = useState([]);
    const [{ contextUser, UserFunctions }] = useContext(AppMainViewContext);
    const branchingQueryDefinitionHash = objectHash(branchingQueryDefinition);
    const searchRootObjectsHash = objectHash(searchRootObjects);
    useEffect(() => {
        debug &&
            console.log('QueryObjectSearch', {
                contextObject: matchedPrimary,
                branchingQueryDefinition,
                scopeDefiningObjects: searchRootObjects,
                targetEdgeParams: resultFilter,
            });
        if (branchingQueryDefinition)
            ConsumerDao.getLinkableItems({
                contextObject: matchedPrimary,
                getLinkableItemsQueryDefinition: branchingQueryDefinition.dehydrate(),
                scopeDefiningObjects: searchRootObjects,
                targetEdgeParams: resultFilter,
                contextUser,
                onlyVisibleToUserGroup: visibleGroupsOnly,
            }).then((res) => {
                debug && console.log('QueryObjectSearch', 'get linkable items res', res);
                if (res.err || !res.data) {
                    UserFunctions.setUserMessage({
                        id: v4(),
                        type: 'MessageBar',
                        severity: Severity.error,
                        label: 'QueryObjectSearch',
                        content: res.err?.message ?? 'No data',
                    });
                    setLinkListItems([]);
                    return;
                }
                if (res.data.Items)
                    setLinkListItems(res.data.Items);
                else
                    setLinkListItems([]);
            });
    }, [branchingQueryDefinitionHash, searchRootObjectsHash]);
    const updateItemSelection = (rowIds, details) => {
        const selectedIds = 'ids' in rowIds ? Array.from(rowIds.ids) : rowIds;
        setSelectedLinkItems(selectedIds.map((id) => details.api.getRow(id)).filter((x) => Boolean(x)));
    };
    /** Assemble rows for data grid */
    const columnMap = { ...viewDefinitionToGridColumnMap(linkableItemsViewDefinition ?? GroupViewDefinition, true) };
    const columns = [DataGridRadioColumn, ...Object.entries(columnMap).map(([k, v]) => ({ field: k, ...v }))];
    const dataGridProps = {
        columns,
        loading: linkListItems === undefined,
        rows: linkListItems,
        getRowClassName: (params) => (params.indexRelativeToCurrentPage % 2 === 0 ? 'even' : 'odd'),
        density: 'compact',
        pageSizeOptions: [10],
        hideFooter: linkListItems === undefined || linkListItems.length === 0,
        hideFooterPagination: linkListItems === undefined || linkListItems.length <= 10,
        checkboxSelection: true,
        onRowSelectionModelChange: updateItemSelection,
        initialState: { sorting: { sortModel: [{ field: 'name', sort: 'asc' }] }, pagination: { paginationModel: { pageSize: 10 } } },
    };
    return (_jsxs(Stack, { gap: 1, children: [_jsx(StripedDataGrid, { style: { fontSize: 'inherit' }, ...dataGridProps }), _jsx(Stack, { direction: "row", justifyContent: "flex-end", children: _jsx(Button, { variant: "contained", startIcon: _jsx(ActionIcons.Link, {}), disabled: selectedLinkItems.length === 0, onClick: () => handleLink(selectedLinkItems), children: "Link" }) })] }));
};
